import {socialPersuasionDataSelector} from '@stencil/hotels-details-reducer/src/selectors';
import React from 'react';
import {useSelector} from 'react-redux';

import SocialPersuasionUI from '../../../../../stories/components/hotels/DetailsPage/SocialPersuasion/SocialPersuasionUI';

const SocialPersuasion = () => {
  const socialPersuasionData = useSelector(socialPersuasionDataSelector);

  if (!socialPersuasionData) {
    return null;
  }

  const rawHeadingData = socialPersuasionData[0];
  const rawFriendsData = socialPersuasionData[1];

  const persuasionHeadingData = {
    text: rawHeadingData?.pt || 'Friends Stayed',
    colors: {
      background: rawHeadingData?.ccd?.bgc,
      text: rawHeadingData?.ccd?.tc,
    },
  };

  const friendsPersuasionData = {
    text: rawFriendsData?.pt,
    colors: {
      background: rawFriendsData?.ccd?.bgc,
      text: rawFriendsData?.ccd?.tc,
    },
  };

  const imageUrl = rawHeadingData?.iul?.[0];

  return (
    <SocialPersuasionUI
      persuasionHeadingData={persuasionHeadingData}
      friendsPersuasionData={friendsPersuasionData}
      imageUrl={imageUrl}
    />
  );
};
export default SocialPersuasion;
